import { z } from "zod";

export const JobSchema = z.object({
  name: z.string().min(1, "Veuillez renseigner le nom du métier."),
  description: z.string().optional().nullable()
});

export type JobSchema = z.infer<typeof JobSchema>;
